// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-header {
  display: flex;
  justify-content: space-between;
  height: 68px;
  padding: 12px 64px;
  border-bottom: 1px solid #dee1e7;
  box-shadow: 0px 6px 36px -4px rgba(15, 23, 40, 0.1411764706);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1400px;
  z-index: 9999;
  background-color: #fff;
}
.home-page-header .home-logo {
  height: 42px;
}
.home-page-header .home-logo img {
  height: 100%;
  width: auto;
}
.home-page-header .home-page-header-links-wrapper {
  display: flex;
  gap: 32px;
  padding: 9px 32px;
  font-weight: 500;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper {
  white-space: nowrap;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .our-products-dropdown-button {
  display: flex;
  font-family: "Inter", Arial, sans-serif !important;
  padding: 0 !important;
  border: none !important;
  background-color: #fff !important;
  color: #445169;
  box-shadow: none !important;
  outline: none !important;
  font-weight: 500;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .our-products-dropdown-button:hover {
  background-color: #fff !important;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .icon-wrapper {
  display: flex;
  align-items: center;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .dropdown-menu {
  right: unset !important;
  top: 30px;
  width: 192px;
  padding: 4px;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .dropdown-menu li {
  margin-bottom: 0;
  height: 40px;
  border: 1px solid #e7f0ff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 3px;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .dropdown-menu li:hover {
  background-color: #e7f0ff;
  border: 1px solid #e7f0ff;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .dropdown-menu li:hover .page-nav-link {
  color: #040e46;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .dropdown .dropdown-menu li .page-nav-link {
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  color: #3571d6;
}
.home-page-header .home-page-header-links-wrapper .home-page-header-link-wrapper .contact-us-btn {
  font-family: "Inter", Arial, sans-serif !important;
  padding: 0 !important;
  border: none !important;
  background-color: #fff !important;
  color: #445169;
  box-shadow: none !important;
  outline: none !important;
  font-weight: 500;
}
.home-page-header .home-page-header-login-wrapper {
  display: flex;
  gap: 28px;
}
.home-page-header .home-page-header-login-wrapper .home-page-header-login {
  color: #448aff;
}
.home-page-header .home-page-header-login-wrapper .home-page-header-login .home-page-header-login-link {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #448aff;
  background-color: #fff;
  border-bottom: 2px solid var(--Greyscale-Grey-20, #dee1e7);
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  width: 96px;
  height: 42px;
  border-radius: 8px;
  border-bottom-width: 2px;
  padding-top: 5px;
  padding-right: 18px;
  padding-bottom: 7px;
  padding-left: 18px;
}
.home-page-header .home-page-header-login-wrapper .home-page-header-login svg {
  flex-shrink: 0;
  vertical-align: middle;
}
.home-page-header .home-page-header-login-wrapper .home-page-header-schedule-demo .home-page-header-schedule-demo-btn {
  background-color: #3571d6;
  width: 176px;
  height: 42px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: none;
  border-bottom: 2px solid #040e46;
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.22), 0px 6px 10px -4px rgba(15, 23, 40, 0.1);
}
.home-page-header .home-page-header-login-wrapper .home-page-header-schedule-demo .home-page-header-schedule-demo-btn svg {
  vertical-align: middle;
}
.home-page-header.mobile {
  height: 53px;
  width: 100vw;
  padding: 12px 20px;
  left: 0;
  transform: unset;
}
.home-page-header.mobile .home-logo {
  height: 27px;
}
.home-page-header.mobile .home-page-header-login-wrapper {
  gap: 8px;
}
.home-page-header.mobile .home-page-header-login-wrapper .home-page-header-login {
  display: flex;
  align-items: center;
}
.home-page-header.mobile .home-page-header-login-wrapper .home-page-header-login .home-page-header-login-link {
  font-size: 12px;
  text-decoration: none;
  width: 50px;
  background-color: unset;
  border-bottom: 0;
  height: 18px;
  padding: unset !important;
}
.home-page-header.mobile .home-page-header-login-wrapper .home-page-header-schedule-demo {
  display: flex;
  align-items: center;
}
.home-page-header.mobile .home-page-header-login-wrapper .home-page-header-schedule-demo .home-page-header-schedule-demo-btn {
  width: 106px;
  font-size: 12px;
  height: 27px;
  border-bottom: 1px solid #040e46;
}
.home-page-header.mobile .home-page-header-login-wrapper .header-menu-btn-wrapper {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.home-page-header.mobile .home-page-header-login-wrapper .header-menu-btn-wrapper .header-menu-btn {
  background-color: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  width: 18px;
  height: 18px;
  padding: 0;
}
.home-page-header.mobile .mobile-menu {
  padding: 27px 32px;
  position: absolute;
  top: 53px;
  left: 0;
  width: 100%;
  background-color: #fff;
  height: calc(100vh - 53px);
}
.home-page-header.mobile .mobile-menu .menu-item {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 24px;
  height: 46px;
  align-items: center;
  line-height: 150%;
  cursor: pointer;
  text-decoration: none;
  color: #3571d6;
  border-bottom: 1px solid #e7f0ff;
}
.home-page-header.mobile .mobile-menu .menu-item:nth-last-of-type(1) {
  border-bottom: unset;
}
.home-page-header.mobile .mobile-menu .menu-item.contact-us-btn {
  background-color: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
}
.home-page-header.mobile .mobile-menu .menu-item.contact-us-btn:hover {
  background-color: none;
  box-shadow: none;
  border: none;
}
.home-page-header.mobile .mobile-menu .menu-item.with-submenu {
  cursor: pointer;
}
.home-page-header.mobile .mobile-menu .menu-item.with-submenu.open {
  border-bottom: unset;
}
.home-page-header.mobile .mobile-menu .menu-item.with-submenu .arrow {
  transition: transform 0.3s ease;
}
.home-page-header.mobile .mobile-menu .menu-item.with-submenu .arrow.open {
  transform: rotate(-90deg);
}
.home-page-header.mobile .mobile-menu .submenu {
  margin-top: 12px;
  margin-bottom: 12px;
}
.home-page-header.mobile .mobile-menu .submenu .submenu-item {
  display: block;
  margin-bottom: 8px;
  color: #445169;
  text-decoration: none;
  font-family: Inter;
  font-weight: 500;
  font-size: 20px;
  line-height: 150%;
}
.home-page-header.mobile .mobile-menu .menu-footer {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}
.home-page-header.mobile .mobile-menu .menu-footer .login-btn,
.home-page-header.mobile .mobile-menu .menu-footer .demo-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.home-page-header.mobile .mobile-menu .menu-footer .login-btn {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #448aff;
  background-color: #fff;
  border-bottom: 2px solid #dee1e7;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  width: 96px;
  height: 42px;
  border-radius: 8px;
  border-bottom-width: 2px;
  padding-top: 5px;
  padding-right: 18px;
  padding-bottom: 7px;
  padding-left: 18px;
}
.home-page-header.mobile .mobile-menu .menu-footer .demo-btn {
  background-color: #3571d6;
  flex-grow: 1;
  height: 42px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: none;
  border-bottom: 2px solid #040e46;
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.22), 0px 6px 10px -4px rgba(15, 23, 40, 0.1);
}
.home-page-header.mobile .mobile-menu .menu-footer .demo-btn svg {
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/Header/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,4DAAA;EACA,+BAAA;EACA,gCAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,YAAA;AACJ;AACI;EACE,YAAA;EACA,WAAA;AACN;AAGE;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AADJ;AAGI;EACE,mBAAA;AADN;AAIQ;EACE,aAAA;EACA,kDAAA;EACA,qBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;EACA,2BAAA;EACA,wBAAA;EACA,gBAAA;AAFV;AAIU;EACE,iCAAA;AAFZ;AAKQ;EACE,aAAA;EACA,mBAAA;AAHV;AAMQ;EACE,uBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,4DAAA;EACA,6DAAA;AAJV;AAMU;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAJZ;AAMY;EACE,yBAAA;EACA,yBAAA;AAJd;AAMc;EACE,cAAA;AAJhB;AAQY;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AANd;AAYM;EACE,kDAAA;EACA,qBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;EACA,2BAAA;EACA,wBAAA;EACA,gBAAA;AAVR;AAeE;EACE,aAAA;EACA,SAAA;AAbJ;AAeI;EACE,cAAA;AAbN;AAeM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAbR;AAgBM;EACE,cAAA;EACA,sBAAA;AAdR;AAmBM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,8FACE;AAlBV;AAqBQ;EACE,sBAAA;AAnBV;AAyBE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,gBAAA;AAvBJ;AAyBI;EACE,YAAA;AAvBN;AA0BI;EACE,QAAA;AAxBN;AA0BM;EACE,aAAA;EACA,mBAAA;AAxBR;AA0BQ;EACE,eAAA;EAEA,qBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AAzBV;AA6BM;EACE,aAAA;EACA,mBAAA;AA3BR;AA6BQ;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;AA3BV;AA+BM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AA7BR;AA+BQ;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA7BV;AAkCI;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,0BAAA;AAhCN;AAkCM;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,gCAAA;AAhCR;AAkCQ;EACE,oBAAA;AAhCV;AAmCQ;EACE,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AAjCV;AAmCU;EACE,sBAAA;EACA,gBAAA;EACA,YAAA;AAjCZ;AAqCQ;EACE,eAAA;AAnCV;AAqCU;EACE,oBAAA;AAnCZ;AAsCU;EACE,+BAAA;AApCZ;AAsCY;EACE,yBAAA;AApCd;AA0CM;EACE,gBAAA;EACA,mBAAA;AAxCR;AA0CQ;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAxCV;AA4CM;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AA1CR;AA4CQ;;EAEE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA1CV;AA6CQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gCAAA;EACA,4DAAA;EACA,6DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA3CV;AA8CQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,8FACE;AA7CZ;AAgDU;EACE,sBAAA;AA9CZ","sourcesContent":[".home-page-header {\n  display: flex;\n  justify-content: space-between;\n  height: 68px;\n  padding: 12px 64px;\n  border-bottom: 1px solid #dee1e7;\n  box-shadow: 0px 6px 36px -4px #0f172824;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  max-width: 1400px;\n  z-index: 9999;\n  background-color: #fff;\n\n  .home-logo {\n    height: 42px;\n\n    img {\n      height: 100%;\n      width: auto;\n    }\n  }\n\n  .home-page-header-links-wrapper {\n    display: flex;\n    gap: 32px;\n    padding: 9px 32px;\n    font-weight: 500;\n\n    .home-page-header-link-wrapper {\n      white-space: nowrap;\n\n      .dropdown {\n        .our-products-dropdown-button {\n          display: flex;\n          font-family: 'Inter', Arial, sans-serif !important;\n          padding: 0 !important;\n          border: none !important;\n          background-color: #fff !important;\n          color: #445169;\n          box-shadow: none !important;\n          outline: none !important;\n          font-weight: 500;\n\n          &:hover {\n            background-color: #fff !important;\n          }\n        }\n        .icon-wrapper {\n          display: flex;\n          align-items: center;\n        }\n\n        .dropdown-menu {\n          right: unset !important;\n          top: 30px;\n          width: 192px;\n          padding: 4px;\n          box-shadow: 0px 6px 10px -4px #0f17281a;\n          box-shadow: 0px 18px 32px -4px #0f172838;\n\n          li {\n            margin-bottom: 0;\n            height: 40px;\n            border: 1px solid #e7f0ff;\n            border-radius: 6px;\n            display: flex;\n            align-items: center;\n            padding: 8px 12px;\n            margin-bottom: 3px;\n\n            &:hover {\n              background-color: #e7f0ff;\n              border: 1px solid #e7f0ff;\n\n              .page-nav-link {\n                color: #040e46;\n              }\n            }\n\n            .page-nav-link {\n              width: 100%;\n              font-size: 16px;\n              font-weight: 500;\n              line-height: 150%;\n              color: #3571d6;\n            }\n          }\n        }\n      }\n\n      .contact-us-btn {\n        font-family: 'Inter', Arial, sans-serif !important;\n        padding: 0 !important;\n        border: none !important;\n        background-color: #fff !important;\n        color: #445169;\n        box-shadow: none !important;\n        outline: none !important;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .home-page-header-login-wrapper {\n    display: flex;\n    gap: 28px;\n\n    .home-page-header-login {\n      color: #448aff;\n\n      .home-page-header-login-link {\n        display: flex;\n        align-items: center;\n        font-size: 14px;\n        font-weight: 600;\n        color: #448aff;\n        background-color: #fff;\n        border-bottom: 2px solid var(--Greyscale-Grey-20, #dee1e7);\n        box-shadow: 0px 6px 10px -4px #0f17281a;\n        box-shadow: 0px 18px 32px -4px #0f172838;\n        width: 96px;\n        height: 42px;\n        border-radius: 8px;\n        border-bottom-width: 2px;\n        padding-top: 5px;\n        padding-right: 18px;\n        padding-bottom: 7px;\n        padding-left: 18px;\n      }\n\n      svg {\n        flex-shrink: 0;\n        vertical-align: middle;\n      }\n    }\n\n    .home-page-header-schedule-demo {\n      .home-page-header-schedule-demo-btn {\n        background-color: #3571d6;\n        width: 176px;\n        height: 42px;\n        border-radius: 8px;\n        font-size: 14px;\n        font-weight: 600;\n        color: #fff;\n        border: none;\n        border-bottom: 2px solid #040e46;\n        box-shadow:\n          0px 18px 32px -4px rgba(15, 23, 40, 0.22),\n          0px 6px 10px -4px rgba(15, 23, 40, 0.1);\n\n        svg {\n          vertical-align: middle;\n        }\n      }\n    }\n  }\n\n  &.mobile {\n    height: 53px;\n    width: 100vw;\n    padding: 12px 20px;\n    left: 0;\n    transform: unset;\n\n    .home-logo {\n      height: 27px;\n    }\n\n    .home-page-header-login-wrapper {\n      gap: 8px;\n\n      .home-page-header-login {\n        display: flex;\n        align-items: center;\n\n        .home-page-header-login-link {\n          font-size: 12px;\n\n          text-decoration: none;\n          width: 50px;\n          background-color: unset;\n          border-bottom: 0;\n          height: 18px;\n          padding: unset !important;\n        }\n      }\n\n      .home-page-header-schedule-demo {\n        display: flex;\n        align-items: center;\n\n        .home-page-header-schedule-demo-btn {\n          width: 106px;\n          font-size: 12px;\n          height: 27px;\n          border-bottom: 1px solid #040e46;\n        }\n      }\n\n      .header-menu-btn-wrapper {\n        display: flex;\n        align-items: center;\n        margin-left: auto;\n\n        .header-menu-btn {\n          background-color: transparent;\n          border: none;\n          outline: none;\n          box-shadow: none;\n          width: 18px;\n          height: 18px;\n          padding: 0;\n        }\n      }\n    }\n\n    .mobile-menu {\n      padding: 27px 32px;\n      position: absolute;\n      top: 53px;\n      left: 0;\n      width: 100%;\n      background-color: #fff;\n      height: calc(100vh - 53px);\n\n      .menu-item {\n        display: flex;\n        justify-content: space-between;\n        font-weight: 600;\n        font-size: 24px;\n        height: 46px;\n        align-items: center;\n        line-height: 150%;\n        cursor: pointer;\n        text-decoration: none;\n        color: #3571d6;\n        border-bottom: 1px solid #e7f0ff;\n\n        &:nth-last-of-type(1) {\n          border-bottom: unset;\n        }\n\n        &.contact-us-btn {\n          background-color: transparent;\n          box-shadow: none;\n          border: none;\n          padding: 0;\n\n          &:hover {\n            background-color: none;\n            box-shadow: none;\n            border: none;\n          }\n        }\n\n        &.with-submenu {\n          cursor: pointer;\n\n          &.open {\n            border-bottom: unset;\n          }\n\n          .arrow {\n            transition: transform 0.3s ease;\n\n            &.open {\n              transform: rotate(-90deg);\n            }\n          }\n        }\n      }\n\n      .submenu {\n        margin-top: 12px;\n        margin-bottom: 12px;\n\n        .submenu-item {\n          display: block;\n          margin-bottom: 8px;\n          color: #445169;\n          text-decoration: none;\n          font-family: Inter;\n          font-weight: 500;\n          font-size: 20px;\n          line-height: 150%;\n        }\n      }\n\n      .menu-footer {\n        margin-top: 20px;\n        display: flex;\n        gap: 10px;\n\n        .login-btn,\n        .demo-btn {\n          padding: 10px 20px;\n          border: none;\n          border-radius: 8px;\n          cursor: pointer;\n        }\n\n        .login-btn {\n          display: flex;\n          align-items: center;\n          font-size: 14px;\n          font-weight: 600;\n          color: #448aff;\n          background-color: #fff;\n          border-bottom: 2px solid #dee1e7;\n          box-shadow: 0px 6px 10px -4px #0f17281a;\n          box-shadow: 0px 18px 32px -4px #0f172838;\n          width: 96px;\n          height: 42px;\n          border-radius: 8px;\n          border-bottom-width: 2px;\n          padding-top: 5px;\n          padding-right: 18px;\n          padding-bottom: 7px;\n          padding-left: 18px;\n        }\n\n        .demo-btn {\n          background-color: #3571d6;\n          flex-grow: 1;\n          height: 42px;\n          border-radius: 8px;\n          font-size: 14px;\n          font-weight: 600;\n          color: #fff;\n          border: none;\n          border-bottom: 2px solid #040e46;\n          box-shadow:\n            0px 18px 32px -4px rgba(15, 23, 40, 0.22),\n            0px 6px 10px -4px rgba(15, 23, 40, 0.1);\n\n          svg {\n            vertical-align: middle;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
